<article #cardContainer>
  <div class="data-container">
    <div class="fixed-data">
      <h3>
        <a [routerLink]="link?.path" [queryParams]="link?.queryParams" [state]="link?.state" [ellipsis]="2">{{ title }}</a>
        <opac-tag *ngIf="issueDate">{{ issueDate | stringToDate:'YYYYMMDD' | date }}</opac-tag>
      </h3>
      <span class="subtitle">
        <a *ngIf="author" class="author" routerLink="/results" [queryParams]="authorQuery">{{ author }}</a>

        <span *ngIf="list" class="list-data">
          <span *ngIf="list.items" class="list-items">
            {{ list.items }} {{ (list.items === 1 ? 'common.item' : 'common.items') | translate }}
          </span>
          <span *ngIf="list.followers" class="list-followers">
            <opac-icon icon="follower"></opac-icon> {{ list.followers }} {{ list.followers === 1 ? 'lists.follower' : 'lists.followers' | translate }}
          </span>
        </span>
      </span>
    </div>

    <ng-content></ng-content>
  </div>

  <div class="cover-container">
    <opac-record-cover [coverUrl]="cover.url" [icon]="cover.icon" [isList]="cover.isList ?? false"></opac-record-cover>
    <opac-progress-bar *ngIf="progress" [progress]="progress.percentage" [progressText]="progress.text ?? '%'"></opac-progress-bar>
  </div>
</article>
